import { Box } from '@mui/material';
import { StyledQuantity } from './style';
import { StyledLightningLinkMainProduct } from './style';

export const LightningLinkMainProduct: React.FC<{
  mainProduct: any;
  salePercentage?: number;
}> = ({ mainProduct, salePercentage = 0 }) => {
  return (
    <StyledLightningLinkMainProduct className="main-product">
      <div className={'product-img'}>
        <img src={mainProduct.images.product} alt="product" />
      </div>
      <div className="text-container">
        <StyledQuantity title={mainProduct.quantityDisplay}>
          {mainProduct.images.productPrefix && (
            <img src={mainProduct.images.productPrefix} alt="coin" />
          )}
          <div className={'quantity_text'}>{mainProduct.quantityDisplay}</div>
        </StyledQuantity>
        {salePercentage > 0 && (
          <Box className="text-container__stroked">
            {mainProduct.strokedSaleQuantity}
          </Box>
        )}
      </div>
    </StyledLightningLinkMainProduct>
  );
};
